import axios from 'axios';
import { call } from 'redux-saga/effects';
import {
    GET_MOVIE_THEATERS_ENDPOINT,
    ADD_CINEMA_TO_FAVORITE_ENDPOINT,
    GET_HALL_CONFIGURATION_ENDPOINT,
    REMOVE_CINEMA_TO_FAVORITE_ENDPOINT,
    GET_MOVIE_THEATERS_WITH_TICKETS_ENDPOINT
} from '../config/apiEndpoints';
import { getTokenHeaders as tokenHeader } from '../helpers/api.helper';

export function* getMovieTheaters(payload) {
    const header = tokenHeader();

    const url = GET_MOVIE_THEATERS_ENDPOINT +
        `&cinema_address_locality=${localStorage.getItem("cinema_location")}` +
        `&items_per_page=10` +
        `&page=${payload}`;

    return yield call(axios.get, url, header);
}

export function* addCinemaOnFavorite(payload) {
    const header = tokenHeader();

    const body = {
        data: {
            type: "favourite_cinema--favourite_cinema",
            relationships: {
                cinema: {
                    data: {
                        type: "cinema--cinema",
                        id: payload
                    }
                }
            }
        }
    }
    return yield call(axios.post, ADD_CINEMA_TO_FAVORITE_ENDPOINT, body, header);
}

export function* removeCinemaOnFavorite(payload) {
    const header = tokenHeader();
    let api_url_dynamic = REMOVE_CINEMA_TO_FAVORITE_ENDPOINT + payload.uuid;

    return yield call(axios.delete, api_url_dynamic, header);
}

export function* getHallConfig(payload) {
    const header = tokenHeader()
    const url = GET_HALL_CONFIGURATION_ENDPOINT + `/1/${payload}/1/1?_format=json`
    return yield call(axios.get, url, header)
}

export function* getMovieTheatersWithTickets(payload) {
    const header = tokenHeader()
    
    const URL = GET_MOVIE_THEATERS_WITH_TICKETS_ENDPOINT +
        `&cinema_address_locality=${localStorage.getItem("cinema_location")}` +
        `&items_per_page=10` +
        `&page=${payload}`;

    return yield call(axios.get, URL, header);
}





// WEBPACK FOOTER //
// ./src/SHARED/api/movietheaters.api.js